import { StorageKeys } from "../types/enums/Storage.enum";
import { storage } from "../utils/Const.utils";
import type { PerfilEntidad } from "../types/interfaces/user.interface";
import { OrigenFuente } from "../types/enums/OrigenFuente.enum";
import { RolEnum } from "../types/enums/TipoRoles.enum";
import { useUserData } from "./useUserData.hook";

export const useOrigenFuenteByTipoPersona = () => {
    const perfil : PerfilEntidad = storage.get(StorageKeys.PERFIL);
    
    let origenFuente : OrigenFuente;
    
    if (perfil?.infoEntidad && [RolEnum.Abogado, RolEnum.Paralegal, RolEnum.Administrador, RolEnum.MinisterioPublico].includes(perfil?.infoEntidad?.relacion?.idRol!)) {
        origenFuente = OrigenFuente.REL_USUARIO_ENTIDADES
    } else {
        origenFuente = OrigenFuente.PORTAL_USUARIO
    }

    return origenFuente
}

export const useIdUsuarioByTipoPersona = () => {
    const perfil : PerfilEntidad = storage.get(StorageKeys.PERFIL);
    const { userData } = useUserData();
    
    let idUsuario;
    
    if (perfil?.infoEntidad && [RolEnum.Abogado, RolEnum.Paralegal, RolEnum.Administrador, RolEnum.MinisterioPublico].includes(perfil?.infoEntidad?.relacion?.idRol!)) {
        idUsuario = perfil.infoEntidad?.relacion.idRelUsuarioEntidades
    } else {
        idUsuario = userData?.id!
    }

    return idUsuario
}